import script from "./ArticleTop.vue?vue&type=script&setup=true&lang=js"
export * from "./ArticleTop.vue?vue&type=script&setup=true&lang=js"

import "./ArticleTop.vue?vue&type=style&index=0&id=70139fcc&lang=scss&scoped=true"

import exportComponent from "/usr/src/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-70139fcc"]])

export default __exports__